import { render } from "./RecordModal.vue?vue&type=template&id=31dbbb3a"
import script from "./RecordModal.vue?vue&type=script&lang=js"
export * from "./RecordModal.vue?vue&type=script&lang=js"

import "./RecordModal.vue?vue&type=style&index=0&id=31dbbb3a&lang=scss"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__